import {
  CustomizationThemeDto,
  UserAppSettingsDto,
  UpdateUserAppSettingsRequest,
  CreateCustomizationThemeRequest,
  UpdateCustomizationThemeRequest,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';

export const appSettingsRequests = {
  getAllCustomizationThemes: EndpointDefinition.get<
    CustomizationThemeDto[],
    { includeDeleted?: boolean }
  >({
    name: 'getAllCustomizationThemes',
    route: '/app_settings/themes',
  }),

  getCustomizationThemeById: EndpointDefinition.get<
    CustomizationThemeDto,
    { id: number }
  >({
    name: 'getCustomizationThemeById',
    route: '/app_settings/themes/:id',
  }),

  createCustomizationTheme: EndpointDefinition.post<
    CustomizationThemeDto,
    CreateCustomizationThemeRequest,
    null
  >({
    name: 'createCustomizationTheme',
    route: '/app_settings/themes',
  }),

  updateCustomizationTheme: EndpointDefinition.patch<
    CustomizationThemeDto,
    UpdateCustomizationThemeRequest,
    { id: number }
  >({
    name: 'updateCustomizationTheme',
    route: '/app_settings/themes/:id',
  }),

  deleteCustomizationTheme: EndpointDefinition.delete<null, { id: number }>({
    name: 'deleteCustomizationTheme',
    route: '/app_settings/themes/:id',
  }),

  getUserAppSettings: EndpointDefinition.get<
    UserAppSettingsDto,
    { userId: string }
  >({
    name: 'getUserAppSettings',
    route: '/app_settings/users/:userId',
  }),

  updateUserAppSettings: EndpointDefinition.patch<
    UserAppSettingsDto,
    UpdateUserAppSettingsRequest,
    { userId: string }
  >({
    name: 'updateUserAppSettings',
    route: '/app_settings/users/:userId',
  }),
};
